import { useMutation } from "react-query";
import { deleteFamilyMentalHealthHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useDeleteFamilyMentalHealthHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    (id: number) => deleteFamilyMentalHealthHistory(id),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while deleting the family mental health history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    deleteFamilyMentalHealthHistoryMutation: mutate,
    isDeleteFamilyMentalHealthHistoryLoading: isLoading,
    ...rest,
  };
};

export default useDeleteFamilyMentalHealthHistory;
